import styled, { css } from "styled-components";
import { propStyling, tombac } from "../../../shared";
import { textStyles } from "../../../shared/textStyles";
const contentsBaseStyles = css(["align-items:center;border-radius:999rem;box-sizing:border-box;display:flex;height:100%;justify-content:center;padding:", ";transition:background-color 0.1s ease-out;white-space:nowrap;"], tombac.space(0, 2));
const contentsActiveBaseStyles = css(["font-family:", ";font-weight:600;"], tombac.altFontFamily);
export const ActiveItemContentPlaceholder = styled.span.withConfig({
  displayName: "ItemContent__ActiveItemContentPlaceholder"
})(["", " ", " opacity:0;user-select:none;"], contentsBaseStyles, contentsActiveBaseStyles);
export const ItemContent = styled.span.withConfig({
  displayName: "ItemContent"
})(["", " ", " ", " ", ""], contentsBaseStyles, _ref => {
  var _checked, _checked2, _checked3, _checked4;
  let {
    isDisabled,
    isHovered,
    isInvalid,
    isPressed,
    isSelected,
    theme: {
      components: {
        toggleGroup: {
          current: {
            item
          } = {}
        }
      }
    }
  } = _ref;
  return [css(["background-color:", ";color:", ";"], tombac.parse(item.backgroundColor), tombac.parse(item.color)), isDisabled && css(["color:", ";"], tombac.parse(item.disabled.color)), isSelected ? css(["", " ", ""], contentsActiveBaseStyles, isDisabled ? css(["background-color:", ";color:", ";"], tombac.parse((_checked = item.disabled.checked) === null || _checked === void 0 ? void 0 : _checked.backgroundColor), tombac.parse((_checked2 = item.disabled.checked) === null || _checked2 === void 0 ? void 0 : _checked2.color)) : css(["background-color:", ";color:", ";", ""], tombac.parse(item.checked.backgroundColor), tombac.parse(item.checked.color), isInvalid && css(["background-color:", ";color:", ";"], tombac.parse((_checked3 = item.invalid.checked) === null || _checked3 === void 0 ? void 0 : _checked3.backgroundColor), tombac.parse((_checked4 = item.invalid.checked) === null || _checked4 === void 0 ? void 0 : _checked4.color)))) : !isDisabled && (isPressed ? css(["background-color:", ";color:", ";"], tombac.parse(item.pressed.backgroundColor), tombac.parse(item.pressed.color)) : isHovered && css(["background-color:", ";color:", ";"], tombac.parse(item.hover.backgroundColor), tombac.parse(item.hover.color)))];
}, propStyling, textStyles);
//# sourceMappingURL=ItemContent.js.map